import { useEffect, useState } from 'react'

// 手寫 hash 路由而非引 react-router：前端只剩對話頁的兩種狀態，
// 為它多背一個 runtime 依賴不划算。
// #1364：開發期檢視器（#/conversations、#/playbooks）已整組移除，這裡不再解析。
export type Route =
  // conversationId 為 null ＝ 開一條新對話；有值 ＝ 續談那一條
  { name: 'chat'; conversationId: string | null }

// 匯出給測試用：驗的是解析規則本身，不必先造出 window.location.hash
export const parseRoute = (hash: string): Route => {
  const segments = hash.replace(/^#\/?/, '').split('/').filter(Boolean)
  // #/c/<id>：續談既有對話。前端不再假設「開新視窗＝新對話」。
  if (segments[0] === 'c' && segments[1]) {
    return { name: 'chat', conversationId: decodeURIComponent(segments[1]) }
  }
  return { name: 'chat', conversationId: null }
}

export const useHashRoute = (): Route => {
  const [route, setRoute] = useState<Route>(() => parseRoute(window.location.hash))
  useEffect(() => {
    const onChange = () => setRoute(parseRoute(window.location.hash))
    window.addEventListener('hashchange', onChange)
    return () => window.removeEventListener('hashchange', onChange)
  }, [])
  return route
}
